import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { ReactComponent as Druida } from '../assets/icons/Druida.svg';
const DEFAULT_EMAIL_PH = "Email";
const DEFAULT_PASSWORD_PH = "Contraseña";
function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailPlaceholder, setEmailPlaceholder] = useState(DEFAULT_EMAIL_PH);
    const [passwordPlaceholder, setPasswordPlaceholder] = useState(DEFAULT_PASSWORD_PH);
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const { user } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            navigate('/shop');
        }
    }, [user, navigate]);
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!email) {
        setEmailPlaceholder('Ingrese su email primero');
        return;
    }
    try {
        await sendPasswordResetEmail(auth, email);
        setEmail('');
        setEmailPlaceholder('Revise su correo para restablecer');
    } catch (err) {
        console.error("Error al enviar reset de contraseña:", err.code);
        setEmailPlaceholder('No se pudo enviar el correo');
    }
  };
  const handleLogin = async (e) => {
e.preventDefault();
setEmailPlaceholder(DEFAULT_EMAIL_PH);
setPasswordPlaceholder(DEFAULT_PASSWORD_PH);
try {
await signInWithEmailAndPassword(auth, email, password);
navigate('/shop');
} catch (err) {
    console.error("Firebase Error Code:", err.code);
    const errorCode = err.code;
    const credentialErrorCodes = [
        'auth/wrong-password',
        'auth/invalid-credential'
    ];
    if (errorCode === 'auth/user-not-found') {
        setEmail('');
        setPassword('');
        setEmailPlaceholder('Usuario no encontrado');
    } else if (credentialErrorCodes.includes(errorCode)) {
        setPassword('');
        setEmailPlaceholder(DEFAULT_EMAIL_PH);
        setPasswordPlaceholder('Contraseña incorrecta');
    } else {
        setEmail('');
        setPassword('');
        setEmailPlaceholder('Error de acceso');
        setPasswordPlaceholder('Error de acceso');
    }
} finally {
    setIsLoggingIn(false);
}
  };
  if (user) {
return (
<div className="login-page">
<h2>Bienvenido, Miembro 👋</h2>
<p>Estás loggeado como: **{user.email}**</p>
</div>
);
  }
  return (
<div className="login-page">
<div className="login-form-container"> 
<Druida style={{fill:'#31173d',height:'30vh',overflow:'visible', width:'auto',margin:' 0'}}/>
<h2 style={{fontSize:'27px', margin: '0 auto 20px',cursor:'default'}}>Acceso Miembros</h2>
<form onSubmit={handleLogin} className="login-form">
 {}
 {}
 <input
 type="email"
 placeholder={emailPlaceholder}
 value={email}
 onChange={(e) => {
 setEmail(e.target.value);
 setEmailPlaceholder(DEFAULT_EMAIL_PH);
 }}
 required
 className={`login-input ${emailPlaceholder !== DEFAULT_EMAIL_PH ? 'input-error' : ''}`}
 />
 {}
 <input
 type="password"
 placeholder={passwordPlaceholder}
 value={password}
 onChange={(e) => {
 setPassword(e.target.value);
 setPasswordPlaceholder(DEFAULT_PASSWORD_PH);
 }}
 required
 className={`login-input ${passwordPlaceholder !== DEFAULT_PASSWORD_PH ? 'input-error' : ''}`}
 />
 <button type="submit" className="login-button" disabled={isLoggingIn}>
 {isLoggingIn ? (
 <span className="login-button-spinner-wrap">
 <span className="login-button-spinner"></span>
 Ingresando...
 </span>
 ) : (
 'Iniciar Sesión'
 )}
 </button>
</form>
<p className="forgot-password-text">
 Si olvidó su contraseña, <a href="#" onClick={handlePasswordReset}>ingrese aquí</a>
</p>
<p className="forgot-password-text">
 Si aún no es miembro, <Link to="/registrarse">suscríbase aquí</Link>
</p>
</div>
</div>
  );
}
export default LoginPage;